function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("mask", {
  id: "mask0",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 66,
  height: 47
}, /*#__PURE__*/React.createElement("rect", {
  width: 66,
  height: 47,
  fill: "white"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 66,
  height: 94,
  rx: 8,
  fill: "#9BACB7"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.09375 11.0322C3.09375 6.61395 6.67547 3.03223 11.0938 3.03223H17.6879C17.6879 3.03223 17.6879 7.39554 20.4603 7.39554C34.6677 7.39554 30.5175 7.39554 45.5502 7.39554C48.0327 7.39554 48.0327 3.03223 48.0327 3.03223H54.9062C59.3245 3.03223 62.9062 6.61395 62.9062 11.0322V86C62.9062 90.4183 59.3245 94 54.9062 94H11.0938C6.67547 94 3.09375 90.4182 3.09375 86V11.0322Z",
  fill: "#E6EBED"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.1875 4.54836C22.1875 5.10013 21.7283 5.56448 21.1406 5.56448C20.5529 5.56448 20.0938 5.10013 20.0938 4.54836C20.0938 3.99658 20.5529 3.53223 21.1406 3.53223C21.7283 3.53223 22.1875 3.99658 22.1875 4.54836Z",
  stroke: "#E6EBED"
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.3438 4.54836C27.3438 5.10013 26.8846 5.56448 26.2969 5.56448C25.7092 5.56448 25.25 5.10013 25.25 4.54836C25.25 3.99658 25.7092 3.53223 26.2969 3.53223C26.8846 3.53223 27.3438 3.99658 27.3438 4.54836Z",
  stroke: "#E6EBED"
}), /*#__PURE__*/React.createElement("path", {
  d: "M45.9062 4.54836C45.9062 5.10013 45.4471 5.56448 44.8594 5.56448C44.2717 5.56448 43.8125 5.10013 43.8125 4.54836C43.8125 3.99658 44.2717 3.53223 44.8594 3.53223C45.4471 3.53223 45.9062 3.99658 45.9062 4.54836Z",
  stroke: "#E6EBED"
}), /*#__PURE__*/React.createElement("rect", {
  x: 29.375,
  y: 3.53223,
  width: 12.4062,
  height: 2.03226,
  rx: 1,
  stroke: "#E6EBED"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_d)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 5.15625,
  y: 13.1396,
  width: 55.6875,
  height: 18.1935,
  rx: 1,
  fill: "white"
})), /*#__PURE__*/React.createElement("path", {
  d: "M11.9355 25.0063C12.0896 25.3367 12.4381 25.5679 12.8427 25.5679C13.2472 25.5679 13.5958 25.3367 13.7498 25.0063H11.9355Z",
  fill: "#042F4B"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.8908 19.8215C13.1587 19.8215 13.416 19.8679 13.6547 19.9528V19.9239C13.6547 19.527 13.3257 19.2041 12.9212 19.2041H12.8605C12.456 19.2041 12.127 19.527 12.127 19.9239V19.9524C12.3656 19.8678 12.6228 19.8215 12.8908 19.8215Z",
  fill: "#042F4B"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.2728 24.632H10.5084C10.4183 24.632 10.3357 24.5731 10.317 24.4875C10.2984 24.4028 10.3382 24.3192 10.4189 24.283C10.4381 24.271 10.5823 24.1732 10.7266 23.8772C10.9917 23.3338 11.0474 22.5682 11.0474 22.0217C11.0474 21.0356 11.8742 20.2334 12.8906 20.2334C13.9045 20.2334 14.7298 21.0318 14.7337 22.0146C14.7338 22.017 14.7339 22.0193 14.7339 22.0217C14.7339 22.5682 14.7895 23.3338 15.0546 23.8772C15.199 24.1732 15.3431 24.271 15.3623 24.283C15.443 24.3192 15.4828 24.4028 15.4642 24.4875C15.4455 24.5731 15.3629 24.632 15.2728 24.632Z",
  fill: "#042F4B"
}), /*#__PURE__*/React.createElement("rect", {
  x: 19.5938,
  y: 17.1826,
  width: 36.0938,
  height: 4.04301,
  rx: 0.5,
  fill: "#9BACB7"
}), /*#__PURE__*/React.createElement("rect", {
  x: 19.5938,
  y: 22.2363,
  width: 19.5938,
  height: 4.04301,
  rx: 0.5,
  fill: "#9BACB7"
}));

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_d",
  x: 3.15625,
  y: 10.1396,
  width: 61.6875,
  height: 24.1935,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1.5
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.772549 0 0 0 0 0.792157 0 0 0 0 0.823529 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})));

function SvgAuthDevice(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 47,
    viewBox: "0 0 66 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthDevice);
export default __webpack_public_path__ + "static/media/authDevice.8ec83ae6.svg";
export { ForwardRef as ReactComponent };